'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const FatigueMeterType=require('../../../dist-es6/shared/domain/fatigueMeterType');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

BreadcrumbsService=function(_BaseService){_inherits(BreadcrumbsService,_BaseService);_createClass(BreadcrumbsService,null,[{key:'$inject',get:function()
{
return['$state','$window','$timeout','userService','elementService','fatigueMeterTypeContentProviderService'];
}}]);

function BreadcrumbsService($state,$window,$timeout,userService,elementService,fatigueMeterTypeContentProviderService){_classCallCheck(this,BreadcrumbsService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._$state=$state;
_this._$window=$window;
_this._$timeout=$timeout;
_this._userService=userService;
_this._elementService=elementService;
_this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;
_this._crumbs=[];return _this;
}BreadcrumbsService.prototype.

startTrail=function startTrail(label){
this._crumbs.length=0;
this.dropCrumb(label);
};BreadcrumbsService.prototype.

dropCrumb=function dropCrumb(label){
let matchingIndex=_.findIndex(this._crumbs,function(crumb){return crumb.originalLabel===label});
if(matchingIndex!==-1){
this._crumbs.length=matchingIndex;
}

this._crumbs.push(this._createCrumb(label,this._$state.current.name));
this._updateWindowTitle(label);
};BreadcrumbsService.prototype.

updateLabelForState=function updateLabelForState(newLabel,expectedState){var _this2=this;
this._$timeout(function(){
_this2._updateLabelForState(newLabel,expectedState);
});
};BreadcrumbsService.prototype.

_updateLabelForState=function _updateLabelForState(newLabel,expectedState){
_.ensureInstanceOf('string',newLabel);
_.ensureInstanceOf('string',expectedState);

const foundCrumb=_.findLast(this._crumbs,{stateName:expectedState});
if(!_.exists(foundCrumb)){
return;
}

foundCrumb.label=newLabel;
if(foundCrumb!==_.last(this._crumbs)){
return;
}

this._updateWindowTitle(newLabel);
};BreadcrumbsService.prototype.

clearCrumbsAndResetWindowTitle=function clearCrumbsAndResetWindowTitle(){
this._crumbs=[];
this._updateWindowTitle(null);
};BreadcrumbsService.prototype.

_updateWindowTitle=function _updateWindowTitle(label){
const newTitle=_.compact([label,this._fatigueMeterTypeContentProviderService.fullAppTitle]).join(' - ');

this._elementService.setText('head title',newTitle);
_.set(this._$window,'document.title',newTitle);

this._elementService.removeAttr('head title','data-ng-bind');
};BreadcrumbsService.prototype.





_createCrumb=function _createCrumb(label,stateName){var _this3=this;
return{
label:label,
stateName:stateName,
originalLabel:label,
follow:function(){return _this3._$state.go(stateName)}};

};_createClass(BreadcrumbsService,[{key:'crumbs',get:function(){return this._crumbs}}]);return BreadcrumbsService}(BaseService);


module.exports=BreadcrumbsService;
//# sourceMappingURL=breadcrumbsService.js.map
